export const CUSTOM_DOMAIN_STAGING = 'm.sanity-cdn.work'
export const CUSTOM_DOMAIN_PRODUCTION = 'm.sanity-cdn.com'
